var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left header-add-icon"},[(_vm.show)?_c('router-link',{staticClass:"d-block",attrs:{"to":"/add"}},[_c('object',{staticClass:"plus-icon",attrs:{"data":_vm.plusSvg,"type":"image/svg+xml"}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }